module.exports = __webpack_public_path__ + "media/images/loader-a6a6686cbddb3e99a5f0b60a829effb3.gif";